// EntryVisibilityCheckbox — 入室画面表示 2 フラグの共有 CB UI
// (entry-preview-members-2026-07-21 案 A).
//
// CreateRoomPage (作成時、ローカル form state に bind) と RoomSettingsModal
// (入室後、toggle → 即 PATCH) の両方から使う。文言は spec
// (application/entryVisibilityFields.ts) 由来で、この component は
// 「CB + ラベル + 説明文」の見た目だけを持つ (保存経路は呼び出し側の責務)。

import type { EntryVisibilityFieldSpec } from '../application/entryVisibilityFields.js';

export interface EntryVisibilityCheckboxProps {
  readonly spec: EntryVisibilityFieldSpec;
  readonly checked: boolean;
  readonly disabled?: boolean;
  readonly onChange: (next: boolean) => void;
}

export const EntryVisibilityCheckbox = ({
  spec,
  checked,
  disabled = false,
  onChange,
}: EntryVisibilityCheckboxProps): React.ReactNode => (
  <div>
    <label className="flex cursor-pointer items-center gap-2 text-sm">
      <input
        type="checkbox"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        disabled={disabled}
      />
      {spec.label}
    </label>
    <p className="mt-1 text-xs text-[var(--color-text-muted)]">{spec.note}</p>
  </div>
);
